<template>
  <ModalDialog
    ref="dialog"
    :title="dialogContent.title"
    :labelOk="dialogContent.okLabel"
    :labelCancel="dialogContent.cancelLabel"
    :posX="posX"
    :posY="posY"
    :dlgStyle="dlgStyle"
    :showCancelIcon="true"
    @ok="redirectToPage()"
    @cancel="closeModal()"
    :displayCancelButton="dialogContent.displayCancelButton"
    :displayOkButton="dialogContent.displayOkLabel" 
  >
    <!-- replace true with isPaymentComplete in displayOkButton -->
    <div class="text-small w-space" v-html="dialogContent.description"></div>
  </ModalDialog>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: 'EditKulibri',

  props: ['type'],

  data() {
    return {
      posX: 0,
      posY: 0,
      dialogContent: {title: '', description: '', cancelLabel: '', okLabel: '', displayOkLabel: true, displayCancelButton: true},
    };
  },

  methods: {
    redirectToPage() {
      if (this.type == 'register') {
        // check if the current url a project link is and if clear admin and public keys
        let redirectUrl = this.$route.path;
        if (redirectUrl) {
          const pathArray = redirectUrl.split('/');
          redirectUrl = '/pr/' + pathArray[2];
        }

        this.$router.push({
          path: '/signin?url=' + redirectUrl,
          redirect: redirectUrl,
          props: true,
        });
      } else {
        if(this.user != null) {
          this.$router.push('/membership');
        } else {
          this.closeModal();
        }
      }
    },

    openModal(event) {
      this.posX = event.clientX;
      this.posY = event.clientY;
      console.log('Position:', this.posX, this.posY);
      this.openKulibriFeatureModal(event);
      // this.$refs.dialog.openModal(event);
    },
    closeModal() {
      this.$refs.dialog.closeModal();
      this.$emit('closeModal');
    },
    openKulibriFeatureModal(event) {
      if(this.user != null) {
          this.dialogContent.title = this.$t('customBrandingTemplate.premiumFeature');
          this.dialogContent.description = this.$t('customBrandingTemplate.useKulibriFeatures') + this.$t('customBrandingTemplate.useKulibriFeatures2');
          this.dialogContent.type = 'registeredUser';
          this.dialogContent.okLabel = this.$t('customBrandingTemplate.checkMyStatus');
          this.dialogContent.cancelLabel = this.$t('customBrandingTemplate.stayHere');
          if(!this.user) {
              this.dialogContent.displayOkLabel = false;
          }
      } else {
          this.dialogContent.title = this.$t('customBrandingTemplate.premiumFeature');
          this.dialogContent.description = this.$t('customBrandingTemplate.useKulibriFeatures') + this.$t('customBrandingTemplate.notRegisteredUser');
          this.dialogContent.type = 'register';
          this.dialogContent.okLabel = this.$t('customBrandingTemplate.ok');
          this.dialogContent.cancelLabel = this.$t('customBrandingTemplate.stayHere');
          this.dialogContent.displayCancelButton = false;
          // this.$refs.dlgPremiumUser.openModal();
      }
      this.$refs.dialog.openModal(event);
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.Login.user,
    }),
    dlgStyle() {
      const dlgWidth = 468;

      const dlgHeight = 360;
      const padding = 20;

      if (this.mobileView) {
        let top = this.posY;
        if (top + dlgHeight + padding > window.innerHeight)
          top = window.innerHeight - dlgHeight - padding;

        return 'margin:' + top + 'px auto';
      }

      let left = this.posX;
      if (left + dlgWidth + padding > window.innerWidth) {
        left = window.innerWidth - dlgWidth - padding;
        console.error('Modal Dialog fixing left:', left);
      }

      let top = this.posY;
      if (top + dlgHeight + padding > window.innerHeight) {
        top = window.innerHeight - dlgHeight - padding;
        console.error('Modal Dialog fixing top:', top);
      }

      const s = ';left:' + left + 'px; top:' + top + 'px';
      console.error('Modal Dialog style:', s, this.modalDialog);
      return s;
    },
    mobileView() {
      return this.$store.state.mobileView;
    }
  },
};
</script>